"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RTTI_BiologicallyDerivedProduct_Storage = exports.BiologicallyDerivedProduct_StorageScaleKind = void 0;
var t = __importStar(require("io-ts"));
var RTTI_Extension_1 = require("./RTTI_Extension");
var RTTI_Element_1 = require("./RTTI_Element");
var RTTI_decimal_1 = require("../Scalar/RTTI_decimal");
var RTTI_Period_1 = require("./RTTI_Period");
var BiologicallyDerivedProduct_StorageScaleKind;
(function (BiologicallyDerivedProduct_StorageScaleKind) {
    BiologicallyDerivedProduct_StorageScaleKind["_farenheit"] = "farenheit";
    BiologicallyDerivedProduct_StorageScaleKind["_celsius"] = "celsius";
    BiologicallyDerivedProduct_StorageScaleKind["_kelvin"] = "kelvin";
})(BiologicallyDerivedProduct_StorageScaleKind = exports.BiologicallyDerivedProduct_StorageScaleKind || (exports.BiologicallyDerivedProduct_StorageScaleKind = {}));
var EnumType_1 = require("../../EnumType");
exports.RTTI_BiologicallyDerivedProduct_Storage = t.recursion('IBiologicallyDerivedProduct_Storage', function () {
    return t.partial({
        id: t.string,
        extension: t.array(RTTI_Extension_1.RTTI_Extension),
        modifierExtension: t.array(RTTI_Extension_1.RTTI_Extension),
        description: t.string,
        _description: RTTI_Element_1.RTTI_Element,
        temperature: RTTI_decimal_1.RTTI_decimal,
        _temperature: RTTI_Element_1.RTTI_Element,
        scale: (0, EnumType_1.createEnumType)(BiologicallyDerivedProduct_StorageScaleKind, 'BiologicallyDerivedProduct_StorageScaleKind'),
        _scale: RTTI_Element_1.RTTI_Element,
        duration: RTTI_Period_1.RTTI_Period
    });
});
//# sourceMappingURL=RTTI_BiologicallyDerivedProduct_Storage.js.map